<template>
    <VueSelect
        v-model="selected"
        :options="options"
        :filter-by="(option, label, search) => matchesSearch(label, search)"
        @update:modelValue="emits('loadModel', selected)"
        :placeholder="translate.placeHolderSelect"
    >
        <template #value="{ option }">
        <div class="custom-value">
            <img :src="option.avatar" class="avatar" v-if="option.avatar">
            <span>{{ option.label }}</span>
        </div>
        </template>

        <template #option="{ option }">
        <p class="custom-option">
            <img :src="option.avatar" class="avatar" v-if="option.avatar">
            {{ option.label }}
        </p>
        </template>
    </VueSelect>            
</template>

<script setup lang="ts">
import VueSelect from "vue3-select-component";
import "vue3-select-component/styles";
import modelsTradutor from "@/tradutors/models";
import { matchesSearch } from "@/shared/utils/normalizeText";

const props = defineProps(["options"]);
const emits = defineEmits(["loadModel"]);
const selected = ref(0);
const route = useRoute();

const translate = computed(() =>
  (route.params.language) == "pt-br"
    ? modelsTradutor.portugues
    : modelsTradutor.ingles
);

</script>

<style scoped lang="css">
:deep(.custom-value) {
  display: flex;
  align-items: center;
  gap: 6px;
}

:deep(.custom-option) {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #171717;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: unset;    
}

:deep(.menu-option) {
  min-height: 56px;
}

:deep(.input-placeholder) {
  color: #c7c7c7;
  font-weight: 500;
  font-size: 16px;
}

/* Mobile: com teclado preditivo (composição IME) o valor só é confirmado ao
   final da composição. Como a lib dimensiona o input pela largura do valor
   (via ::after/data-value), o texto digitado ficava cortado e só aparecia ao
   tocar. Ao FOCAR, forçamos o input a ocupar a largura toda para o texto ficar
   visível enquanto se digita. O escopo .control.focused evita que o input
   full-width cubra o valor selecionado (avatar + nome) quando em repouso. */
:deep(.control.focused .input-container) {
  display: flex !important;
  width: 100% !important;
}

:deep(.control.focused .search-input) {
  width: 100% !important;
  min-width: 0 !important;
  flex: 1 1 auto !important;
}

/* oculta o placeholder quando focado, para não sobrepor o texto em composição */
:deep(.control.focused .input-placeholder) {
  display: none;
}

:deep(.control) {
  padding: 0 !important;
  padding-left: 20px !important;
  font-size: 1rem !important;
  background-color: #f8f8f8 !important;
  border: 1px solid #ced4da !important;
  border-radius: 30px !important;
  height: 51px !important;
  width: 100%;
}

:deep(.dropdown-icon) {
    width: 30px;
    height: 30px;
    color: #b20000;
}

:deep(.menu-option.focused:not(.selected):not(.disabled)) {
    background-color: #f4f4f4;
}

:deep(.control.focused) {
    border-color: #ced4da !important;
    box-shadow: unset !important;
}

:deep(.menu) {
    max-height: 300px;
    top: -10px !important;
}

.avatar {
  width: 50px;
  height: 38px;
  margin-right: 10px;
  vertical-align: middle;
}

@media screen and (max-width: 769px) {
    :deep(.control) {
        background-color: #ffffff !important;
    }
}
</style>
